var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49866 3.25847V13.0782C6.49866 13.5874 6.08603 14 5.57691 14C5.0678 14 4.65516 13.5874 4.65516 13.0782V3.25847L1.65225 6.26139C1.27432 6.63932 0.661517 6.63932 0.283447 6.26139C-0.0944822 5.88331 -0.0944822 5.27051 0.283447 4.89259L4.89259 0.283447C5.27052 -0.0944822 5.88348 -0.0944822 6.26139 0.283447L10.8705 4.89259C11.2485 5.27052 11.2485 5.88332 10.8705 6.26139C10.4925 6.63932 9.87965 6.63932 9.50174 6.26139L6.49866 3.25847Z",
    fill: "#2b2b2b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/arrowUp-black.8b4ca198fb179d015ef7f75ceb20a260.svg";
export { ForwardRef as ReactComponent };